import { useTranslation } from "react-i18next"
import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Settings } from "lucide-react"

interface ConfigurationCustomizeProps {
  data: any
  onChange: (data: any) => void
  onValid: (valid: boolean) => void
}

export const ConfigurationCustomize = ({ data, onChange }: ConfigurationCustomizeProps) => {
  const { t } = useTranslation()

  const options = [
    {
      key: "useLegacyLabelling",
      title: t("configurationCustomize.useLegacyLabelling"),
      description: "Use the older labelling system for product categories",
    },
  ]

  return (
    <div className="max-w-2xl">
      <Card>
        <CardHeader className="pb-3">
          <div className="flex items-center gap-2">
            <Settings className="size-4 text-muted-foreground" />
            <CardTitle className="text-sm font-medium">
              {t("configurationCustomize.title")}
            </CardTitle>
          </div>
          <CardDescription className="text-xs">
            Advanced customization options for the widget
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {options.map(({ key, title, description }) => (
              <div key={key} className="flex items-start gap-2.5">
                <Checkbox
                  id={key}
                  checked={data.config[key] || false}
                  onCheckedChange={() =>
                    onChange({
                      ...data,
                      config: { ...data.config, [key]: !data.config[key] },
                    })
                  }
                  className="mt-0.5"
                />
                <div>
                  <Label htmlFor={key} className="cursor-pointer text-sm">
                    {title}
                  </Label>
                  <p className="text-xs text-muted-foreground">{description}</p>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
